/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
} from "@angular/common/http";
import { CustomHttpParameterCodec } from "../encoder";
import { Observable } from "rxjs";

import { GeoLocationCreditResponseModel } from "../model/models";
import { ImportInventoryCountingResponseModel } from "../model/models";
import { ImportWorkOrderRequestModel } from "../model/models";
import { InvTranBySiteDashboard } from "../model/models";
import { InvTranCompleteModel } from "../model/models";
import { InvTranDetModel } from "../model/models";
import { InvTranFulfillCustomerOrderModel } from "../model/models";
import { InvTranInsertModel } from "../model/models";
import { InvTranModel } from "../model/models";
import { InvTranResponseModel } from "../model/models";
import { InvTranSuggestedEstimatedSalesModel } from "../model/models";
import { InvTranSuggestedItemRequestModel } from "../model/models";
import { InvTranUpdateModel } from "../model/models";
import { InventoryCountingFilter } from "../model/models";
import { ReportResponseModel } from "../model/models";
import { ShelfLifeBySiteDashboard } from "../model/models";
import { ShelfLifeBySiteGeoLocation } from "../model/models";
import { TraceabilityGeoLocationResponseModel } from "../model/models";
import { WebFilter } from "../model/models";
import { WorkOrderModel } from "../model/models";

import { BASE_PATH, COLLECTION_FORMATS } from "../variables";
import { Configuration } from "../configuration";

export interface ApiInvTranAllGetRequestParams {
  pickerGroup?: string;
  pickerItem?: string;
  fromDate?: string;
  toDate?: string;
  search?: string;
  docTypeId?: number;
  locationId?: number;
  pageNumber?: number;
  pageSize?: number;
}

export interface ApiInvTranBarcodeScanBarcodeScanGetRequestParams {
  barcodeScan: string;
}

export interface ApiInvTranBarcodeScanGetRequestParams {
  invTranId?: number;
  invTranTypeId?: number;
  locationId?: number;
  siteId?: number;
  barcodeScan?: string;
  fulfillItemNumber?: string;
}

export interface ApiInvTranBarcodeScanLocationIdBarcodeScanGetRequestParams {
  locationId: number;
  barcodeScan: string;
}

export interface ApiInvTranCompleteWorkOrderPutRequestParams {
  invTranCompleteModel?: InvTranCompleteModel;
}

export interface ApiInvTranConvertGPAdjmentIdPostRequestParams {
  id: number;
}

export interface ApiInvTranCreditAllGetRequestParams {
  pickerGroup?: string;
  pickerItem?: string;
  fromDate?: string;
  toDate?: string;
  search?: string;
  workflowStatusId?: string;
  locationId?: number;
  pageNumber?: number;
  pageSize?: number;
}

export interface ApiInvTranCreditsConvertToReturnIdPostRequestParams {
  id: number;
}

export interface ApiInvTranCreditsExportPostRequestParams {
  webFilter?: WebFilter;
}

export interface ApiInvTranDeleteIdDeleteRequestParams {
  id: number;
}

export interface ApiInvTranDeleteInvTranCreditIdDeleteRequestParams {
  id: number;
}

export interface ApiInvTranDeleteInvTranWorkOrderIdDeleteRequestParams {
  id: number;
}

export interface ApiInvTranFulfillCustomerOrderPostRequestParams {
  invTranFulfillCustomerOrderModel?: InvTranFulfillCustomerOrderModel;
}

export interface ApiInvTranGeolocationcreditexportGetRequestParams {
  locationId?: number;
  periodDays?: number;
  datePicker?: string;
  customerSearch?: string;
  userNameSearch?: string;
}

export interface ApiInvTranGeolocationcreditsGetRequestParams {
  locationId?: number;
  periodDays?: number;
  datePicker?: string;
  customerSearch?: string;
  userNameSearch?: string;
}

export interface ApiInvTranIdGetRequestParams {
  id: number;
}

export interface ApiInvTranImportFreshShelfIdGetRequestParams {
  id: number;
}

export interface ApiInvTranImportInventoryCountingPostRequestParams {
  inventoryCountingFilter?: InventoryCountingFilter;
}

export interface ApiInvTranInsertPostRequestParams {
  invTranInsertModel?: InvTranInsertModel;
}

export interface ApiInvTranInvTranWorkorderIdGetRequestParams {
  id: number;
}

export interface ApiInvTranInvTranWorkorderPostRequestParams {
  importWorkOrderRequestModel?: ImportWorkOrderRequestModel;
}

export interface ApiInvTranInvtranbysitePostRequestParams {
  webFilter?: WebFilter;
}

export interface ApiInvTranInvtranbysitedashboardPostRequestParams {
  webFilter?: WebFilter;
}

export interface ApiInvTranInvtranmissedfulfillmentPostRequestParams {
  webFilter?: WebFilter;
}

export interface ApiInvTranInvtranreportIdGetRequestParams {
  id: number;
}

export interface ApiInvTranInvtranreturnsummaryreportIdGetRequestParams {
  id: number;
}

export interface ApiInvTranInvtranshelflifebysitePostRequestParams {
  webFilter?: WebFilter;
}

export interface ApiInvTranInvtransummarydetailPostRequestParams {
  webFilter?: WebFilter;
}

export interface ApiInvTranInvtranworeportIdGetRequestParams {
  id: number;
}

export interface ApiInvTranReOpenWorkOrderInvTranIdPutRequestParams {
  invTranId: number;
}

export interface ApiInvTranSSCCBarcodeScanGetRequestParams {
  invTranId?: number;
  invTranTypeId?: number;
  locationId?: number;
  siteId?: number;
  barcodeScan?: string;
  fulfillItemNumber?: string;
}

export interface ApiInvTranShelfLifeBySiteExportPostRequestParams {
  webFilter?: WebFilter;
}

export interface ApiInvTranShelfLifeFreshAllGetRequestParams {
  pickerGroup?: string;
  pickerItem?: string;
  fromDate?: string;
  toDate?: string;
  search?: string;
  docTypeId?: number;
  locationId?: number;
  siteId?: number;
  pageNumber?: number;
  pageSize?: number;
}

export interface ApiInvTranShelfLifeFreshToImportGetRequestParams {
  search?: string;
  locationId?: number;
  siteId?: number;
  pageNumber?: number;
  pageSize?: number;
}

export interface ApiInvTranShelflifebysitedashboardPostRequestParams {
  webFilter?: WebFilter;
}

export interface ApiInvTranShelflifebysitegeolocationPostRequestParams {
  webFilter?: WebFilter;
}

export interface ApiInvTranSuggestedEstimatedSalesByItemPostRequestParams {
  invTranSuggestedItemRequestModel?: InvTranSuggestedItemRequestModel;
}

export interface ApiInvTranSuggestedEstimatedSalesPostRequestParams {
  invTranSuggestedEstimatedSalesModel?: InvTranSuggestedEstimatedSalesModel;
}

export interface ApiInvTranTraceabilitygeolocationGetRequestParams {
  batchIdentifier?: string;
  itemSearchFilter?: string;
  periodDays?: number;
}

export interface ApiInvTranTraceabilitygeolocationexportGetRequestParams {
  batchIdentifier?: string;
  itemSearchFilter?: string;
  periodDays?: number;
}

export interface ApiInvTranUpdatePutRequestParams {
  invTranUpdateModel?: InvTranUpdateModel;
}

export interface ApiInvTranWorkOrderAllGetRequestParams {
  pickerGroup?: string;
  pickerItem?: string;
  fromDate?: string;
  toDate?: string;
  search?: string;
  workflowStatusId?: string;
  workflowCompletedType?: number;
  docTypeId?: number;
  locationId?: number;
  pageNumber?: number;
  pageSize?: number;
}

export interface ApiInvTranWosummaryreportIdGetRequestParams {
  id: number;
}

export interface ApiInvTranWotallysheetreportIdGetRequestParams {
  id: number;
}

@Injectable({
  providedIn: "root",
})
export class InvTranService {
  protected basePath = "";
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== "string") {
      if (typeof basePath !== "string") {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(
    httpParams: HttpParams,
    value: any,
    key?: string,
  ): HttpParams {
    if (typeof value === "object" && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(
    httpParams: HttpParams,
    value?: any,
    key?: string,
  ): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === "object") {
      if (Array.isArray(value)) {
        (value as any[]).forEach(
          (elem) =>
            (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)),
        );
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(
            key,
            (value as Date).toISOString().substr(0, 10),
          );
        } else {
          throw Error("key may not be null if value is Date");
        }
      } else {
        Object.keys(value).forEach(
          (k) =>
            (httpParams = this.addToHttpParamsRecursive(
              httpParams,
              value[k],
              key != null ? `${key}.${k}` : k,
            )),
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error("key may not be null if value is not object or array");
    }
    return httpParams;
  }

  /**
   * Get All InvTrans
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranAllGet(
    requestParameters: ApiInvTranAllGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<Array<InvTranResponseModel>>;
  public apiInvTranAllGet(
    requestParameters: ApiInvTranAllGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<Array<InvTranResponseModel>>>;
  public apiInvTranAllGet(
    requestParameters: ApiInvTranAllGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<Array<InvTranResponseModel>>>;
  public apiInvTranAllGet(
    requestParameters: ApiInvTranAllGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const pickerGroup = requestParameters.pickerGroup;
    const pickerItem = requestParameters.pickerItem;
    const fromDate = requestParameters.fromDate;
    const toDate = requestParameters.toDate;
    const search = requestParameters.search;
    const docTypeId = requestParameters.docTypeId;
    const locationId = requestParameters.locationId;
    const pageNumber = requestParameters.pageNumber;
    const pageSize = requestParameters.pageSize;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (pickerGroup !== undefined && pickerGroup !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pickerGroup,
        "PickerGroup",
      );
    }
    if (pickerItem !== undefined && pickerItem !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pickerItem,
        "PickerItem",
      );
    }
    if (fromDate !== undefined && fromDate !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>fromDate,
        "FromDate",
      );
    }
    if (toDate !== undefined && toDate !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>toDate,
        "ToDate",
      );
    }
    if (search !== undefined && search !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>search,
        "search",
      );
    }
    if (docTypeId !== undefined && docTypeId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>docTypeId,
        "docTypeId",
      );
    }
    if (locationId !== undefined && locationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>locationId,
        "locationId",
      );
    }
    if (pageNumber !== undefined && pageNumber !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageNumber,
        "pageNumber",
      );
    }
    if (pageSize !== undefined && pageSize !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageSize,
        "pageSize",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<Array<InvTranResponseModel>>(
      `${this.configuration.basePath}/api/InvTran/all`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * add Barcode Scan param barcodeScan
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranBarcodeScanBarcodeScanGet(
    requestParameters: ApiInvTranBarcodeScanBarcodeScanGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiInvTranBarcodeScanBarcodeScanGet(
    requestParameters: ApiInvTranBarcodeScanBarcodeScanGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiInvTranBarcodeScanBarcodeScanGet(
    requestParameters: ApiInvTranBarcodeScanBarcodeScanGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiInvTranBarcodeScanBarcodeScanGet(
    requestParameters: ApiInvTranBarcodeScanBarcodeScanGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const barcodeScan = requestParameters.barcodeScan;
    if (barcodeScan === null || barcodeScan === undefined) {
      throw new Error(
        "Required parameter barcodeScan was null or undefined when calling apiInvTranBarcodeScanBarcodeScanGet.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<any>(
      `${
        this.configuration.basePath
      }/api/InvTran/BarcodeScan/${encodeURIComponent(String(barcodeScan))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Add Barcode Scan by Location body: InvTran Barcode Request Model
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranBarcodeScanGet(
    requestParameters: ApiInvTranBarcodeScanGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiInvTranBarcodeScanGet(
    requestParameters: ApiInvTranBarcodeScanGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiInvTranBarcodeScanGet(
    requestParameters: ApiInvTranBarcodeScanGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiInvTranBarcodeScanGet(
    requestParameters: ApiInvTranBarcodeScanGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const invTranId = requestParameters.invTranId;
    const invTranTypeId = requestParameters.invTranTypeId;
    const locationId = requestParameters.locationId;
    const siteId = requestParameters.siteId;
    const barcodeScan = requestParameters.barcodeScan;
    const fulfillItemNumber = requestParameters.fulfillItemNumber;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (invTranId !== undefined && invTranId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>invTranId,
        "InvTranId",
      );
    }
    if (invTranTypeId !== undefined && invTranTypeId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>invTranTypeId,
        "InvTranTypeId",
      );
    }
    if (locationId !== undefined && locationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>locationId,
        "LocationId",
      );
    }
    if (siteId !== undefined && siteId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>siteId,
        "SiteId",
      );
    }
    if (barcodeScan !== undefined && barcodeScan !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>barcodeScan,
        "BarcodeScan",
      );
    }
    if (fulfillItemNumber !== undefined && fulfillItemNumber !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>fulfillItemNumber,
        "FulfillItemNumber",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<any>(
      `${this.configuration.basePath}/api/InvTran/BarcodeScan`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Add Barcode Scan params locationId and barcodeScan
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranBarcodeScanLocationIdBarcodeScanGet(
    requestParameters: ApiInvTranBarcodeScanLocationIdBarcodeScanGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiInvTranBarcodeScanLocationIdBarcodeScanGet(
    requestParameters: ApiInvTranBarcodeScanLocationIdBarcodeScanGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiInvTranBarcodeScanLocationIdBarcodeScanGet(
    requestParameters: ApiInvTranBarcodeScanLocationIdBarcodeScanGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiInvTranBarcodeScanLocationIdBarcodeScanGet(
    requestParameters: ApiInvTranBarcodeScanLocationIdBarcodeScanGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const locationId = requestParameters.locationId;
    if (locationId === null || locationId === undefined) {
      throw new Error(
        "Required parameter locationId was null or undefined when calling apiInvTranBarcodeScanLocationIdBarcodeScanGet.",
      );
    }
    const barcodeScan = requestParameters.barcodeScan;
    if (barcodeScan === null || barcodeScan === undefined) {
      throw new Error(
        "Required parameter barcodeScan was null or undefined when calling apiInvTranBarcodeScanLocationIdBarcodeScanGet.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<any>(
      `${
        this.configuration.basePath
      }/api/InvTran/BarcodeScan/${encodeURIComponent(
        String(locationId),
      )}/${encodeURIComponent(String(barcodeScan))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Complete InvTran (Work Order)
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranCompleteWorkOrderPut(
    requestParameters: ApiInvTranCompleteWorkOrderPutRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiInvTranCompleteWorkOrderPut(
    requestParameters: ApiInvTranCompleteWorkOrderPutRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiInvTranCompleteWorkOrderPut(
    requestParameters: ApiInvTranCompleteWorkOrderPutRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiInvTranCompleteWorkOrderPut(
    requestParameters: ApiInvTranCompleteWorkOrderPutRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const invTranCompleteModel = requestParameters.invTranCompleteModel;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.put<any>(
      `${this.configuration.basePath}/api/InvTran/CompleteWorkOrder`,
      invTranCompleteModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Convert GP Adjusment into a Receiving Transaction.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranConvertGPAdjmentIdPost(
    requestParameters: ApiInvTranConvertGPAdjmentIdPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<InvTranModel>;
  public apiInvTranConvertGPAdjmentIdPost(
    requestParameters: ApiInvTranConvertGPAdjmentIdPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<InvTranModel>>;
  public apiInvTranConvertGPAdjmentIdPost(
    requestParameters: ApiInvTranConvertGPAdjmentIdPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<InvTranModel>>;
  public apiInvTranConvertGPAdjmentIdPost(
    requestParameters: ApiInvTranConvertGPAdjmentIdPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiInvTranConvertGPAdjmentIdPost.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<InvTranModel>(
      `${
        this.configuration.basePath
      }/api/InvTran/ConvertGPAdjment/${encodeURIComponent(String(id))}`,
      null,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get All InvTrans
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranCreditAllGet(
    requestParameters: ApiInvTranCreditAllGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<Array<InvTranResponseModel>>;
  public apiInvTranCreditAllGet(
    requestParameters: ApiInvTranCreditAllGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<Array<InvTranResponseModel>>>;
  public apiInvTranCreditAllGet(
    requestParameters: ApiInvTranCreditAllGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<Array<InvTranResponseModel>>>;
  public apiInvTranCreditAllGet(
    requestParameters: ApiInvTranCreditAllGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const pickerGroup = requestParameters.pickerGroup;
    const pickerItem = requestParameters.pickerItem;
    const fromDate = requestParameters.fromDate;
    const toDate = requestParameters.toDate;
    const search = requestParameters.search;
    const workflowStatusId = requestParameters.workflowStatusId;
    const locationId = requestParameters.locationId;
    const pageNumber = requestParameters.pageNumber;
    const pageSize = requestParameters.pageSize;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (pickerGroup !== undefined && pickerGroup !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pickerGroup,
        "PickerGroup",
      );
    }
    if (pickerItem !== undefined && pickerItem !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pickerItem,
        "PickerItem",
      );
    }
    if (fromDate !== undefined && fromDate !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>fromDate,
        "FromDate",
      );
    }
    if (toDate !== undefined && toDate !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>toDate,
        "ToDate",
      );
    }
    if (search !== undefined && search !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>search,
        "search",
      );
    }
    if (workflowStatusId !== undefined && workflowStatusId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>workflowStatusId,
        "workflowStatusId",
      );
    }
    if (locationId !== undefined && locationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>locationId,
        "locationId",
      );
    }
    if (pageNumber !== undefined && pageNumber !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageNumber,
        "pageNumber",
      );
    }
    if (pageSize !== undefined && pageSize !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageSize,
        "pageSize",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<Array<InvTranResponseModel>>(
      `${this.configuration.basePath}/api/InvTran/CreditAll`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranCreditsConvertToReturnIdPost(
    requestParameters: ApiInvTranCreditsConvertToReturnIdPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiInvTranCreditsConvertToReturnIdPost(
    requestParameters: ApiInvTranCreditsConvertToReturnIdPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiInvTranCreditsConvertToReturnIdPost(
    requestParameters: ApiInvTranCreditsConvertToReturnIdPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiInvTranCreditsConvertToReturnIdPost(
    requestParameters: ApiInvTranCreditsConvertToReturnIdPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiInvTranCreditsConvertToReturnIdPost.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "text";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<any>(
      `${
        this.configuration.basePath
      }/api/InvTran/Credits/ConvertToReturn/${encodeURIComponent(String(id))}`,
      null,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Export to Excel Credits Detail
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranCreditsExportPost(
    requestParameters: ApiInvTranCreditsExportPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiInvTranCreditsExportPost(
    requestParameters: ApiInvTranCreditsExportPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiInvTranCreditsExportPost(
    requestParameters: ApiInvTranCreditsExportPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiInvTranCreditsExportPost(
    requestParameters: ApiInvTranCreditsExportPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const webFilter = requestParameters.webFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<ReportResponseModel>(
      `${this.configuration.basePath}/api/InvTran/CreditsExport`,
      webFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Delete InvTran
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranDeleteIdDelete(
    requestParameters: ApiInvTranDeleteIdDeleteRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiInvTranDeleteIdDelete(
    requestParameters: ApiInvTranDeleteIdDeleteRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiInvTranDeleteIdDelete(
    requestParameters: ApiInvTranDeleteIdDeleteRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiInvTranDeleteIdDelete(
    requestParameters: ApiInvTranDeleteIdDeleteRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiInvTranDeleteIdDelete.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.delete<any>(
      `${this.configuration.basePath}/api/InvTran/Delete/${encodeURIComponent(
        String(id),
      )}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranDeleteInvTranCreditIdDelete(
    requestParameters: ApiInvTranDeleteInvTranCreditIdDeleteRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiInvTranDeleteInvTranCreditIdDelete(
    requestParameters: ApiInvTranDeleteInvTranCreditIdDeleteRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiInvTranDeleteInvTranCreditIdDelete(
    requestParameters: ApiInvTranDeleteInvTranCreditIdDeleteRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiInvTranDeleteInvTranCreditIdDelete(
    requestParameters: ApiInvTranDeleteInvTranCreditIdDeleteRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiInvTranDeleteInvTranCreditIdDelete.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "text";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.delete<any>(
      `${
        this.configuration.basePath
      }/api/InvTran/DeleteInvTranCredit/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranDeleteInvTranWorkOrderIdDelete(
    requestParameters: ApiInvTranDeleteInvTranWorkOrderIdDeleteRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiInvTranDeleteInvTranWorkOrderIdDelete(
    requestParameters: ApiInvTranDeleteInvTranWorkOrderIdDeleteRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiInvTranDeleteInvTranWorkOrderIdDelete(
    requestParameters: ApiInvTranDeleteInvTranWorkOrderIdDeleteRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiInvTranDeleteInvTranWorkOrderIdDelete(
    requestParameters: ApiInvTranDeleteInvTranWorkOrderIdDeleteRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiInvTranDeleteInvTranWorkOrderIdDelete.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "text";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.delete<any>(
      `${
        this.configuration.basePath
      }/api/InvTran/DeleteInvTranWorkOrder/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranFulfillCustomerOrderPost(
    requestParameters: ApiInvTranFulfillCustomerOrderPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiInvTranFulfillCustomerOrderPost(
    requestParameters: ApiInvTranFulfillCustomerOrderPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiInvTranFulfillCustomerOrderPost(
    requestParameters: ApiInvTranFulfillCustomerOrderPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiInvTranFulfillCustomerOrderPost(
    requestParameters: ApiInvTranFulfillCustomerOrderPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const invTranFulfillCustomerOrderModel =
      requestParameters.invTranFulfillCustomerOrderModel;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<any>(
      `${this.configuration.basePath}/api/InvTran/FulfillCustomerOrder`,
      invTranFulfillCustomerOrderModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Export credit geo-location events.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranGeolocationcreditexportGet(
    requestParameters: ApiInvTranGeolocationcreditexportGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiInvTranGeolocationcreditexportGet(
    requestParameters: ApiInvTranGeolocationcreditexportGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiInvTranGeolocationcreditexportGet(
    requestParameters: ApiInvTranGeolocationcreditexportGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiInvTranGeolocationcreditexportGet(
    requestParameters: ApiInvTranGeolocationcreditexportGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const locationId = requestParameters.locationId;
    const periodDays = requestParameters.periodDays;
    const datePicker = requestParameters.datePicker;
    const customerSearch = requestParameters.customerSearch;
    const userNameSearch = requestParameters.userNameSearch;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (locationId !== undefined && locationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>locationId,
        "locationId",
      );
    }
    if (periodDays !== undefined && periodDays !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>periodDays,
        "periodDays",
      );
    }
    if (datePicker !== undefined && datePicker !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>datePicker,
        "datePicker",
      );
    }
    if (customerSearch !== undefined && customerSearch !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>customerSearch,
        "customerSearch",
      );
    }
    if (userNameSearch !== undefined && userNameSearch !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>userNameSearch,
        "userNameSearch",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<ReportResponseModel>(
      `${this.configuration.basePath}/api/InvTran/geolocationcreditexport`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get credit geo-location events.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranGeolocationcreditsGet(
    requestParameters: ApiInvTranGeolocationcreditsGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<Array<GeoLocationCreditResponseModel>>;
  public apiInvTranGeolocationcreditsGet(
    requestParameters: ApiInvTranGeolocationcreditsGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<Array<GeoLocationCreditResponseModel>>>;
  public apiInvTranGeolocationcreditsGet(
    requestParameters: ApiInvTranGeolocationcreditsGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<Array<GeoLocationCreditResponseModel>>>;
  public apiInvTranGeolocationcreditsGet(
    requestParameters: ApiInvTranGeolocationcreditsGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const locationId = requestParameters.locationId;
    const periodDays = requestParameters.periodDays;
    const datePicker = requestParameters.datePicker;
    const customerSearch = requestParameters.customerSearch;
    const userNameSearch = requestParameters.userNameSearch;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (locationId !== undefined && locationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>locationId,
        "locationId",
      );
    }
    if (periodDays !== undefined && periodDays !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>periodDays,
        "periodDays",
      );
    }
    if (datePicker !== undefined && datePicker !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>datePicker,
        "datePicker",
      );
    }
    if (customerSearch !== undefined && customerSearch !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>customerSearch,
        "customerSearch",
      );
    }
    if (userNameSearch !== undefined && userNameSearch !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>userNameSearch,
        "userNameSearch",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<Array<GeoLocationCreditResponseModel>>(
      `${this.configuration.basePath}/api/InvTran/geolocationcredits`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get InvTran by Id
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranIdGet(
    requestParameters: ApiInvTranIdGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<InvTranModel>;
  public apiInvTranIdGet(
    requestParameters: ApiInvTranIdGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<InvTranModel>>;
  public apiInvTranIdGet(
    requestParameters: ApiInvTranIdGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<InvTranModel>>;
  public apiInvTranIdGet(
    requestParameters: ApiInvTranIdGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiInvTranIdGet.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<InvTranModel>(
      `${this.configuration.basePath}/api/InvTran/${encodeURIComponent(
        String(id),
      )}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Import Work Order to Inventory Transaction
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranImportFreshShelfIdGet(
    requestParameters: ApiInvTranImportFreshShelfIdGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<Array<InvTranDetModel>>;
  public apiInvTranImportFreshShelfIdGet(
    requestParameters: ApiInvTranImportFreshShelfIdGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<Array<InvTranDetModel>>>;
  public apiInvTranImportFreshShelfIdGet(
    requestParameters: ApiInvTranImportFreshShelfIdGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<Array<InvTranDetModel>>>;
  public apiInvTranImportFreshShelfIdGet(
    requestParameters: ApiInvTranImportFreshShelfIdGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiInvTranImportFreshShelfIdGet.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<Array<InvTranDetModel>>(
      `${
        this.configuration.basePath
      }/api/InvTran/ImportFreshShelf/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Import selected inventory counts into a Fresh Shelf transaction.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranImportInventoryCountingPost(
    requestParameters: ApiInvTranImportInventoryCountingPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ImportInventoryCountingResponseModel>;
  public apiInvTranImportInventoryCountingPost(
    requestParameters: ApiInvTranImportInventoryCountingPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ImportInventoryCountingResponseModel>>;
  public apiInvTranImportInventoryCountingPost(
    requestParameters: ApiInvTranImportInventoryCountingPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ImportInventoryCountingResponseModel>>;
  public apiInvTranImportInventoryCountingPost(
    requestParameters: ApiInvTranImportInventoryCountingPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const inventoryCountingFilter = requestParameters.inventoryCountingFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<ImportInventoryCountingResponseModel>(
      `${this.configuration.basePath}/api/InvTran/ImportInventoryCounting`,
      inventoryCountingFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Insert InvTran
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranInsertPost(
    requestParameters: ApiInvTranInsertPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiInvTranInsertPost(
    requestParameters: ApiInvTranInsertPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiInvTranInsertPost(
    requestParameters: ApiInvTranInsertPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiInvTranInsertPost(
    requestParameters: ApiInvTranInsertPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const invTranInsertModel = requestParameters.invTranInsertModel;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<any>(
      `${this.configuration.basePath}/api/InvTran/Insert`,
      invTranInsertModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get Work Order by Id
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranInvTranWorkorderIdGet(
    requestParameters: ApiInvTranInvTranWorkorderIdGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<WorkOrderModel>;
  public apiInvTranInvTranWorkorderIdGet(
    requestParameters: ApiInvTranInvTranWorkorderIdGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<WorkOrderModel>>;
  public apiInvTranInvTranWorkorderIdGet(
    requestParameters: ApiInvTranInvTranWorkorderIdGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<WorkOrderModel>>;
  public apiInvTranInvTranWorkorderIdGet(
    requestParameters: ApiInvTranInvTranWorkorderIdGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiInvTranInvTranWorkorderIdGet.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<WorkOrderModel>(
      `${
        this.configuration.basePath
      }/api/InvTran/InvTran/workorder/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Import Work Order to Inventory Transaction
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranInvTranWorkorderPost(
    requestParameters: ApiInvTranInvTranWorkorderPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<Array<InvTranDetModel>>;
  public apiInvTranInvTranWorkorderPost(
    requestParameters: ApiInvTranInvTranWorkorderPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<Array<InvTranDetModel>>>;
  public apiInvTranInvTranWorkorderPost(
    requestParameters: ApiInvTranInvTranWorkorderPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<Array<InvTranDetModel>>>;
  public apiInvTranInvTranWorkorderPost(
    requestParameters: ApiInvTranInvTranWorkorderPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const importWorkOrderRequestModel =
      requestParameters.importWorkOrderRequestModel;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<Array<InvTranDetModel>>(
      `${this.configuration.basePath}/api/InvTran/InvTran/workorder`,
      importWorkOrderRequestModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Inventory Transaction By Site Report/Export
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranInvtranbysitePost(
    requestParameters: ApiInvTranInvtranbysitePostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiInvTranInvtranbysitePost(
    requestParameters: ApiInvTranInvtranbysitePostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiInvTranInvtranbysitePost(
    requestParameters: ApiInvTranInvtranbysitePostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiInvTranInvtranbysitePost(
    requestParameters: ApiInvTranInvtranbysitePostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const webFilter = requestParameters.webFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<ReportResponseModel>(
      `${this.configuration.basePath}/api/InvTran/invtranbysite`,
      webFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Inventory Transaction By Site Dashboard
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranInvtranbysitedashboardPost(
    requestParameters: ApiInvTranInvtranbysitedashboardPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<InvTranBySiteDashboard>;
  public apiInvTranInvtranbysitedashboardPost(
    requestParameters: ApiInvTranInvtranbysitedashboardPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<InvTranBySiteDashboard>>;
  public apiInvTranInvtranbysitedashboardPost(
    requestParameters: ApiInvTranInvtranbysitedashboardPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<InvTranBySiteDashboard>>;
  public apiInvTranInvtranbysitedashboardPost(
    requestParameters: ApiInvTranInvtranbysitedashboardPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const webFilter = requestParameters.webFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<InvTranBySiteDashboard>(
      `${this.configuration.basePath}/api/InvTran/invtranbysitedashboard`,
      webFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Inventory Transaction By Site Report/Export
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranInvtranmissedfulfillmentPost(
    requestParameters: ApiInvTranInvtranmissedfulfillmentPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiInvTranInvtranmissedfulfillmentPost(
    requestParameters: ApiInvTranInvtranmissedfulfillmentPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiInvTranInvtranmissedfulfillmentPost(
    requestParameters: ApiInvTranInvtranmissedfulfillmentPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiInvTranInvtranmissedfulfillmentPost(
    requestParameters: ApiInvTranInvtranmissedfulfillmentPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const webFilter = requestParameters.webFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<ReportResponseModel>(
      `${this.configuration.basePath}/api/InvTran/invtranmissedfulfillment`,
      webFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Inventory Transaction Document Report
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranInvtranreportIdGet(
    requestParameters: ApiInvTranInvtranreportIdGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<object>;
  public apiInvTranInvtranreportIdGet(
    requestParameters: ApiInvTranInvtranreportIdGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<object>>;
  public apiInvTranInvtranreportIdGet(
    requestParameters: ApiInvTranInvtranreportIdGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<object>>;
  public apiInvTranInvtranreportIdGet(
    requestParameters: ApiInvTranInvtranreportIdGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiInvTranInvtranreportIdGet.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<object>(
      `${
        this.configuration.basePath
      }/api/InvTran/invtranreport/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Inventory Transaction Return Summary Report
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranInvtranreturnsummaryreportIdGet(
    requestParameters: ApiInvTranInvtranreturnsummaryreportIdGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<object>;
  public apiInvTranInvtranreturnsummaryreportIdGet(
    requestParameters: ApiInvTranInvtranreturnsummaryreportIdGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<object>>;
  public apiInvTranInvtranreturnsummaryreportIdGet(
    requestParameters: ApiInvTranInvtranreturnsummaryreportIdGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<object>>;
  public apiInvTranInvtranreturnsummaryreportIdGet(
    requestParameters: ApiInvTranInvtranreturnsummaryreportIdGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiInvTranInvtranreturnsummaryreportIdGet.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<object>(
      `${
        this.configuration.basePath
      }/api/InvTran/invtranreturnsummaryreport/${encodeURIComponent(
        String(id),
      )}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Inventory Transaction Shelf Life By Site Report/Export
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranInvtranshelflifebysitePost(
    requestParameters: ApiInvTranInvtranshelflifebysitePostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiInvTranInvtranshelflifebysitePost(
    requestParameters: ApiInvTranInvtranshelflifebysitePostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiInvTranInvtranshelflifebysitePost(
    requestParameters: ApiInvTranInvtranshelflifebysitePostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiInvTranInvtranshelflifebysitePost(
    requestParameters: ApiInvTranInvtranshelflifebysitePostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const webFilter = requestParameters.webFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<ReportResponseModel>(
      `${this.configuration.basePath}/api/InvTran/invtranshelflifebysite`,
      webFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Inventory Transaction By Site Report/Export
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranInvtransummarydetailPost(
    requestParameters: ApiInvTranInvtransummarydetailPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiInvTranInvtransummarydetailPost(
    requestParameters: ApiInvTranInvtransummarydetailPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiInvTranInvtransummarydetailPost(
    requestParameters: ApiInvTranInvtransummarydetailPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiInvTranInvtransummarydetailPost(
    requestParameters: ApiInvTranInvtransummarydetailPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const webFilter = requestParameters.webFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<ReportResponseModel>(
      `${this.configuration.basePath}/api/InvTran/invtransummarydetail`,
      webFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Inventory Transaction Document Report
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranInvtranworeportIdGet(
    requestParameters: ApiInvTranInvtranworeportIdGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<object>;
  public apiInvTranInvtranworeportIdGet(
    requestParameters: ApiInvTranInvtranworeportIdGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<object>>;
  public apiInvTranInvtranworeportIdGet(
    requestParameters: ApiInvTranInvtranworeportIdGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<object>>;
  public apiInvTranInvtranworeportIdGet(
    requestParameters: ApiInvTranInvtranworeportIdGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiInvTranInvtranworeportIdGet.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<object>(
      `${
        this.configuration.basePath
      }/api/InvTran/invtranworeport/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * ReOpen WorkOrder
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranReOpenWorkOrderInvTranIdPut(
    requestParameters: ApiInvTranReOpenWorkOrderInvTranIdPutRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiInvTranReOpenWorkOrderInvTranIdPut(
    requestParameters: ApiInvTranReOpenWorkOrderInvTranIdPutRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiInvTranReOpenWorkOrderInvTranIdPut(
    requestParameters: ApiInvTranReOpenWorkOrderInvTranIdPutRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiInvTranReOpenWorkOrderInvTranIdPut(
    requestParameters: ApiInvTranReOpenWorkOrderInvTranIdPutRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const invTranId = requestParameters.invTranId;
    if (invTranId === null || invTranId === undefined) {
      throw new Error(
        "Required parameter invTranId was null or undefined when calling apiInvTranReOpenWorkOrderInvTranIdPut.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.put<any>(
      `${
        this.configuration.basePath
      }/api/InvTran/ReOpenWorkOrder/${encodeURIComponent(String(invTranId))}`,
      null,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * SSC Barcode Scan record
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranSSCCBarcodeScanGet(
    requestParameters: ApiInvTranSSCCBarcodeScanGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiInvTranSSCCBarcodeScanGet(
    requestParameters: ApiInvTranSSCCBarcodeScanGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiInvTranSSCCBarcodeScanGet(
    requestParameters: ApiInvTranSSCCBarcodeScanGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiInvTranSSCCBarcodeScanGet(
    requestParameters: ApiInvTranSSCCBarcodeScanGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const invTranId = requestParameters.invTranId;
    const invTranTypeId = requestParameters.invTranTypeId;
    const locationId = requestParameters.locationId;
    const siteId = requestParameters.siteId;
    const barcodeScan = requestParameters.barcodeScan;
    const fulfillItemNumber = requestParameters.fulfillItemNumber;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (invTranId !== undefined && invTranId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>invTranId,
        "InvTranId",
      );
    }
    if (invTranTypeId !== undefined && invTranTypeId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>invTranTypeId,
        "InvTranTypeId",
      );
    }
    if (locationId !== undefined && locationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>locationId,
        "LocationId",
      );
    }
    if (siteId !== undefined && siteId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>siteId,
        "SiteId",
      );
    }
    if (barcodeScan !== undefined && barcodeScan !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>barcodeScan,
        "BarcodeScan",
      );
    }
    if (fulfillItemNumber !== undefined && fulfillItemNumber !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>fulfillItemNumber,
        "FulfillItemNumber",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<any>(
      `${this.configuration.basePath}/api/InvTran/SSCCBarcodeScan`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Inventory Transaction Shelf Life By Site Export
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranShelfLifeBySiteExportPost(
    requestParameters: ApiInvTranShelfLifeBySiteExportPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiInvTranShelfLifeBySiteExportPost(
    requestParameters: ApiInvTranShelfLifeBySiteExportPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiInvTranShelfLifeBySiteExportPost(
    requestParameters: ApiInvTranShelfLifeBySiteExportPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiInvTranShelfLifeBySiteExportPost(
    requestParameters: ApiInvTranShelfLifeBySiteExportPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const webFilter = requestParameters.webFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<ReportResponseModel>(
      `${this.configuration.basePath}/api/InvTran/ShelfLifeBySiteExport`,
      webFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get All InvTrans
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranShelfLifeFreshAllGet(
    requestParameters: ApiInvTranShelfLifeFreshAllGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<Array<InvTranResponseModel>>;
  public apiInvTranShelfLifeFreshAllGet(
    requestParameters: ApiInvTranShelfLifeFreshAllGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<Array<InvTranResponseModel>>>;
  public apiInvTranShelfLifeFreshAllGet(
    requestParameters: ApiInvTranShelfLifeFreshAllGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<Array<InvTranResponseModel>>>;
  public apiInvTranShelfLifeFreshAllGet(
    requestParameters: ApiInvTranShelfLifeFreshAllGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const pickerGroup = requestParameters.pickerGroup;
    const pickerItem = requestParameters.pickerItem;
    const fromDate = requestParameters.fromDate;
    const toDate = requestParameters.toDate;
    const search = requestParameters.search;
    const docTypeId = requestParameters.docTypeId;
    const locationId = requestParameters.locationId;
    const siteId = requestParameters.siteId;
    const pageNumber = requestParameters.pageNumber;
    const pageSize = requestParameters.pageSize;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (pickerGroup !== undefined && pickerGroup !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pickerGroup,
        "PickerGroup",
      );
    }
    if (pickerItem !== undefined && pickerItem !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pickerItem,
        "PickerItem",
      );
    }
    if (fromDate !== undefined && fromDate !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>fromDate,
        "FromDate",
      );
    }
    if (toDate !== undefined && toDate !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>toDate,
        "ToDate",
      );
    }
    if (search !== undefined && search !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>search,
        "search",
      );
    }
    if (docTypeId !== undefined && docTypeId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>docTypeId,
        "docTypeId",
      );
    }
    if (locationId !== undefined && locationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>locationId,
        "locationId",
      );
    }
    if (siteId !== undefined && siteId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>siteId,
        "siteId",
      );
    }
    if (pageNumber !== undefined && pageNumber !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageNumber,
        "pageNumber",
      );
    }
    if (pageSize !== undefined && pageSize !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageSize,
        "pageSize",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<Array<InvTranResponseModel>>(
      `${this.configuration.basePath}/api/InvTran/ShelfLifeFreshAll`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get All InvTrans
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranShelfLifeFreshToImportGet(
    requestParameters: ApiInvTranShelfLifeFreshToImportGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<Array<InvTranResponseModel>>;
  public apiInvTranShelfLifeFreshToImportGet(
    requestParameters: ApiInvTranShelfLifeFreshToImportGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<Array<InvTranResponseModel>>>;
  public apiInvTranShelfLifeFreshToImportGet(
    requestParameters: ApiInvTranShelfLifeFreshToImportGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<Array<InvTranResponseModel>>>;
  public apiInvTranShelfLifeFreshToImportGet(
    requestParameters: ApiInvTranShelfLifeFreshToImportGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const search = requestParameters.search;
    const locationId = requestParameters.locationId;
    const siteId = requestParameters.siteId;
    const pageNumber = requestParameters.pageNumber;
    const pageSize = requestParameters.pageSize;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>search,
        "search",
      );
    }
    if (locationId !== undefined && locationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>locationId,
        "locationId",
      );
    }
    if (siteId !== undefined && siteId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>siteId,
        "siteId",
      );
    }
    if (pageNumber !== undefined && pageNumber !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageNumber,
        "pageNumber",
      );
    }
    if (pageSize !== undefined && pageSize !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageSize,
        "pageSize",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<Array<InvTranResponseModel>>(
      `${this.configuration.basePath}/api/InvTran/ShelfLifeFreshToImport`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Inventory Transaction Shelf Life By Site Dashboard
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranShelflifebysitedashboardPost(
    requestParameters: ApiInvTranShelflifebysitedashboardPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ShelfLifeBySiteDashboard>;
  public apiInvTranShelflifebysitedashboardPost(
    requestParameters: ApiInvTranShelflifebysitedashboardPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ShelfLifeBySiteDashboard>>;
  public apiInvTranShelflifebysitedashboardPost(
    requestParameters: ApiInvTranShelflifebysitedashboardPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ShelfLifeBySiteDashboard>>;
  public apiInvTranShelflifebysitedashboardPost(
    requestParameters: ApiInvTranShelflifebysitedashboardPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const webFilter = requestParameters.webFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<ShelfLifeBySiteDashboard>(
      `${this.configuration.basePath}/api/InvTran/shelflifebysitedashboard`,
      webFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Inventory Transaction Shelf Life By Site Geo Location
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranShelflifebysitegeolocationPost(
    requestParameters: ApiInvTranShelflifebysitegeolocationPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<Array<ShelfLifeBySiteGeoLocation>>;
  public apiInvTranShelflifebysitegeolocationPost(
    requestParameters: ApiInvTranShelflifebysitegeolocationPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<Array<ShelfLifeBySiteGeoLocation>>>;
  public apiInvTranShelflifebysitegeolocationPost(
    requestParameters: ApiInvTranShelflifebysitegeolocationPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<Array<ShelfLifeBySiteGeoLocation>>>;
  public apiInvTranShelflifebysitegeolocationPost(
    requestParameters: ApiInvTranShelflifebysitegeolocationPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const webFilter = requestParameters.webFilter;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<Array<ShelfLifeBySiteGeoLocation>>(
      `${this.configuration.basePath}/api/InvTran/shelflifebysitegeolocation`,
      webFilter,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranSuggestedEstimatedSalesByItemPost(
    requestParameters: ApiInvTranSuggestedEstimatedSalesByItemPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiInvTranSuggestedEstimatedSalesByItemPost(
    requestParameters: ApiInvTranSuggestedEstimatedSalesByItemPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiInvTranSuggestedEstimatedSalesByItemPost(
    requestParameters: ApiInvTranSuggestedEstimatedSalesByItemPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiInvTranSuggestedEstimatedSalesByItemPost(
    requestParameters: ApiInvTranSuggestedEstimatedSalesByItemPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const invTranSuggestedItemRequestModel =
      requestParameters.invTranSuggestedItemRequestModel;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<any>(
      `${this.configuration.basePath}/api/InvTran/SuggestedEstimatedSalesByItem`,
      invTranSuggestedItemRequestModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranSuggestedEstimatedSalesPost(
    requestParameters: ApiInvTranSuggestedEstimatedSalesPostRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiInvTranSuggestedEstimatedSalesPost(
    requestParameters: ApiInvTranSuggestedEstimatedSalesPostRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiInvTranSuggestedEstimatedSalesPost(
    requestParameters: ApiInvTranSuggestedEstimatedSalesPostRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiInvTranSuggestedEstimatedSalesPost(
    requestParameters: ApiInvTranSuggestedEstimatedSalesPostRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const invTranSuggestedEstimatedSalesModel =
      requestParameters.invTranSuggestedEstimatedSalesModel;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.post<any>(
      `${this.configuration.basePath}/api/InvTran/SuggestedEstimatedSales`,
      invTranSuggestedEstimatedSalesModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get traceability geo-location display.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranTraceabilitygeolocationGet(
    requestParameters: ApiInvTranTraceabilitygeolocationGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<TraceabilityGeoLocationResponseModel>;
  public apiInvTranTraceabilitygeolocationGet(
    requestParameters: ApiInvTranTraceabilitygeolocationGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<TraceabilityGeoLocationResponseModel>>;
  public apiInvTranTraceabilitygeolocationGet(
    requestParameters: ApiInvTranTraceabilitygeolocationGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<TraceabilityGeoLocationResponseModel>>;
  public apiInvTranTraceabilitygeolocationGet(
    requestParameters: ApiInvTranTraceabilitygeolocationGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const batchIdentifier = requestParameters.batchIdentifier;
    const itemSearchFilter = requestParameters.itemSearchFilter;
    const periodDays = requestParameters.periodDays;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (batchIdentifier !== undefined && batchIdentifier !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>batchIdentifier,
        "batchIdentifier",
      );
    }
    if (itemSearchFilter !== undefined && itemSearchFilter !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>itemSearchFilter,
        "itemSearchFilter",
      );
    }
    if (periodDays !== undefined && periodDays !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>periodDays,
        "periodDays",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<TraceabilityGeoLocationResponseModel>(
      `${this.configuration.basePath}/api/InvTran/traceabilitygeolocation`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Export traceability geo-location display.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranTraceabilitygeolocationexportGet(
    requestParameters: ApiInvTranTraceabilitygeolocationexportGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<ReportResponseModel>;
  public apiInvTranTraceabilitygeolocationexportGet(
    requestParameters: ApiInvTranTraceabilitygeolocationexportGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<ReportResponseModel>>;
  public apiInvTranTraceabilitygeolocationexportGet(
    requestParameters: ApiInvTranTraceabilitygeolocationexportGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<ReportResponseModel>>;
  public apiInvTranTraceabilitygeolocationexportGet(
    requestParameters: ApiInvTranTraceabilitygeolocationexportGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const batchIdentifier = requestParameters.batchIdentifier;
    const itemSearchFilter = requestParameters.itemSearchFilter;
    const periodDays = requestParameters.periodDays;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (batchIdentifier !== undefined && batchIdentifier !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>batchIdentifier,
        "batchIdentifier",
      );
    }
    if (itemSearchFilter !== undefined && itemSearchFilter !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>itemSearchFilter,
        "itemSearchFilter",
      );
    }
    if (periodDays !== undefined && periodDays !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>periodDays,
        "periodDays",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<ReportResponseModel>(
      `${this.configuration.basePath}/api/InvTran/traceabilitygeolocationexport`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Update InvTran
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranUpdatePut(
    requestParameters: ApiInvTranUpdatePutRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any>;
  public apiInvTranUpdatePut(
    requestParameters: ApiInvTranUpdatePutRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpResponse<any>>;
  public apiInvTranUpdatePut(
    requestParameters: ApiInvTranUpdatePutRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<HttpEvent<any>>;
  public apiInvTranUpdatePut(
    requestParameters: ApiInvTranUpdatePutRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined },
  ): Observable<any> {
    const invTranUpdateModel = requestParameters.invTranUpdateModel;

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json",
      "text/json",
      "application/_*+json",
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.put<any>(
      `${this.configuration.basePath}/api/InvTran/Update`,
      invTranUpdateModel,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get All InvTrans
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranWorkOrderAllGet(
    requestParameters: ApiInvTranWorkOrderAllGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<Array<InvTranResponseModel>>;
  public apiInvTranWorkOrderAllGet(
    requestParameters: ApiInvTranWorkOrderAllGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<Array<InvTranResponseModel>>>;
  public apiInvTranWorkOrderAllGet(
    requestParameters: ApiInvTranWorkOrderAllGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<Array<InvTranResponseModel>>>;
  public apiInvTranWorkOrderAllGet(
    requestParameters: ApiInvTranWorkOrderAllGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const pickerGroup = requestParameters.pickerGroup;
    const pickerItem = requestParameters.pickerItem;
    const fromDate = requestParameters.fromDate;
    const toDate = requestParameters.toDate;
    const search = requestParameters.search;
    const workflowStatusId = requestParameters.workflowStatusId;
    const workflowCompletedType = requestParameters.workflowCompletedType;
    const docTypeId = requestParameters.docTypeId;
    const locationId = requestParameters.locationId;
    const pageNumber = requestParameters.pageNumber;
    const pageSize = requestParameters.pageSize;

    let queryParameters = new HttpParams({ encoder: this.encoder });
    if (pickerGroup !== undefined && pickerGroup !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pickerGroup,
        "PickerGroup",
      );
    }
    if (pickerItem !== undefined && pickerItem !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pickerItem,
        "PickerItem",
      );
    }
    if (fromDate !== undefined && fromDate !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>fromDate,
        "FromDate",
      );
    }
    if (toDate !== undefined && toDate !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>toDate,
        "ToDate",
      );
    }
    if (search !== undefined && search !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>search,
        "search",
      );
    }
    if (workflowStatusId !== undefined && workflowStatusId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>workflowStatusId,
        "workflowStatusId",
      );
    }
    if (workflowCompletedType !== undefined && workflowCompletedType !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>workflowCompletedType,
        "workflowCompletedType",
      );
    }
    if (docTypeId !== undefined && docTypeId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>docTypeId,
        "docTypeId",
      );
    }
    if (locationId !== undefined && locationId !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>locationId,
        "locationId",
      );
    }
    if (pageNumber !== undefined && pageNumber !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageNumber,
        "pageNumber",
      );
    }
    if (pageSize !== undefined && pageSize !== null) {
      queryParameters = this.addToHttpParams(
        queryParameters,
        <any>pageSize,
        "pageSize",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<Array<InvTranResponseModel>>(
      `${this.configuration.basePath}/api/InvTran/WorkOrderAll`,
      {
        params: queryParameters,
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * WO Summary Document Report
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranWosummaryreportIdGet(
    requestParameters: ApiInvTranWosummaryreportIdGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<object>;
  public apiInvTranWosummaryreportIdGet(
    requestParameters: ApiInvTranWosummaryreportIdGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<object>>;
  public apiInvTranWosummaryreportIdGet(
    requestParameters: ApiInvTranWosummaryreportIdGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<object>>;
  public apiInvTranWosummaryreportIdGet(
    requestParameters: ApiInvTranWosummaryreportIdGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiInvTranWosummaryreportIdGet.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<object>(
      `${
        this.configuration.basePath
      }/api/InvTran/wosummaryreport/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * WO Tally Sheet Document Report
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiInvTranWotallysheetreportIdGet(
    requestParameters: ApiInvTranWotallysheetreportIdGetRequestParams,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<object>;
  public apiInvTranWotallysheetreportIdGet(
    requestParameters: ApiInvTranWotallysheetreportIdGetRequestParams,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpResponse<object>>;
  public apiInvTranWotallysheetreportIdGet(
    requestParameters: ApiInvTranWotallysheetreportIdGetRequestParams,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<HttpEvent<object>>;
  public apiInvTranWotallysheetreportIdGet(
    requestParameters: ApiInvTranWotallysheetreportIdGetRequestParams,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "text/plain" | "application/json" | "text/json";
    },
  ): Observable<any> {
    const id = requestParameters.id;
    if (id === null || id === undefined) {
      throw new Error(
        "Required parameter id was null or undefined when calling apiInvTranWotallysheetreportIdGet.",
      );
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    let httpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [
        "text/plain",
        "application/json",
        "text/json",
      ];
      httpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (
      httpHeaderAcceptSelected &&
      httpHeaderAcceptSelected.startsWith("text")
    ) {
      responseType = "text";
    }

    return this.httpClient.get<object>(
      `${
        this.configuration.basePath
      }/api/InvTran/wotallysheetreport/${encodeURIComponent(String(id))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }
}
